export class ForgotPasswordRequest {
  constructor(public email: string = '') {}
}
